/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Top_Rated_LabelInputs */

const en_common_header_explore_top_rated_label = /** @type {(inputs: Common_Header_Explore_Top_Rated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Rated`)
};

const zh_common_header_explore_top_rated_label = /** @type {(inputs: Common_Header_Explore_Top_Rated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高分之选`)
};

/**
* | output |
* | --- |
* | "Top Rated" |
*
* @param {Common_Header_Explore_Top_Rated_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_top_rated_label = /** @type {((inputs?: Common_Header_Explore_Top_Rated_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Top_Rated_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_top_rated_label(inputs)
	return zh_common_header_explore_top_rated_label(inputs)
});
export { common_header_explore_top_rated_label as "common.header.explore.top_rated.label" }